import { compare, Guard } from "lib/actions/util";
import { Moment } from "moment";

export const sort = <T>(
  items: T[],
  selector: (item: T) => string | number | Date | Moment,
  asc = true,
) => {
  Guard.require(selector, "selector");
  const f = asc
    ? (a: T, b: T) => compare(selector(a), selector(b))
    : (a: T, b: T) => compare(selector(b), selector(a));
  return items?.sort(f);
};
